module.exports = __webpack_public_path__ + "img/d-mytown-logo-black.8aa86fb3.png";